module.exports = __webpack_public_path__ + "img/20241209_1.69d104b1.jpg";